import React, { useState } from "react";
import "./culture_card.css";
import Ucmodal from "../modal/Modal";
function CultureCard({
  imageURL,
  heading,
  description,
  keyPoints,
  modalImage,
}) {
  const [showModal, setShowModal] = useState(false);
  return (
    <div>
      <img
        className="culture-card-style"
        src={imageURL}
        onClick={() => setShowModal(true)}
      />
      {showModal && (
        <Ucmodal
          heading={heading}
          setShowModal={setShowModal}
          description={description}
          imageURL={modalImage.web}
          keyPoints={keyPoints}
          isMobile={window.innerWidth < 768}
        />
      )}
    </div>
  );
}
export default CultureCard;
